<template lang="pug">
    div
        div(v-if='user')
            item-state-modal(
                v-if="isItemCreated || isItemUpdated || isItemDeleted",
                :is-updated="isItemUpdated",
                :is-created="isItemCreated",
                :is-deleted="isItemDeleted",
                @close="setDefaultStates"
            )
            list-box(v-if="$can('viewList', type)")
                template(slot='excel' v-if='isExcelAvailable && type !== "transactions"')
                    .field-column
                        cs-button(
                            color="blue",
                            pattern="primary-outline",
                            html-tag="a",
                            target='_blank'
                            :href='getExcelExportUrl()'
                            :narrow="isNarrowButtons"
                        )
                            svg-icon(name="tablet" size="large" slot="icon")
                            | {{ $i18n.t('list.list_list_open') }}
                            | Excel
                template(slot='excel' v-if='isExcelAvailable && type === "transactions"')
                    .field-column
                        cs-button(
                            color="blue",
                            pattern="primary-outline",
                            html-tag="a",
                            target='_blank'
                            @click="requestGenerateExcel"
                            :narrow="isNarrowButtons"
                        )
                            i(class="fa fa-spinner fa-spin" v-if="isExcelLoading" slot="icon")
                            svg-icon(name="tablet" size="large" slot="icon")
                            | {{ $i18n.t('list.list_list_prepare_report') }}
                    .field-column(v-if="isShowDownloadButton")
                        cs-button(
                            color="blue",
                            class="button-download-excel",
                            pattern="primary-outline",
                            html-tag="a",
                            target='_blank'
                            :href='linkExcelFile'
                            :narrow="isNarrowButtons"
                        )
                            | {{ $i18n.t('list.list_list_open') }}
                            | Excel
                template(slot='button' v-if='isCreateButtonAvailable')
                    .field-column(v-if="type === 'presentations'", :class="{'field-column__link': isExcelAvailable}")
                        cs-button.button-link(
                            color='blue',
                            pattern='primary-outline'
                            @click=`$router.push({
                                  name: isEducationMaterials ? 'education-materials-theme:create' : 'presentations-theme:create',
                                  params: {
                                      type: isEducationMaterials ? 'education-material' : type
                                  }
                            })`,
                            v-if="$can('addItem', type)",
                            :disabled='areSchoolsBlocked'
                            :narrow="isNarrowButtons"
                        )
                            svg-icon(name="plus" size="large" slot="icon")
                            | {{ $i18n.t('list.list_list_add') }}
                            | {{ declination['presentations-theme']['add'] }}
                    .field-column(:class="{'field-column__link': isExcelAvailable || type === 'presentations'}")
                        cs-button.button-link(
                            slot="button",
                            :color="isNarrowButtons ? 'blue' : 'green'",
                            pattern='primary-outline',
                            @click=`$router.push({
                                name: routeName,
                                params: {
                                    type: isEducationMaterials ? 'education-material' : type
                                }
                            })`
                            v-if="$can('addItem', type) && type !== 'tariffs' && type !== 'teacher'",
                            :disabled='isLoading || blockAccessToButton || areSchoolsBlocked'
                            :narrow="isNarrowButtons"
                        )
                            svg-icon(name="plus" size="large" slot="icon")
                            | {{ $i18n.t('list.list_list_add') }} {{ declination[type]['add'] }}
                        .tariff-header-actions(v-if="type === 'tariffs'")
                            cs-button.button-link(
                                    color="blue",
                                    v-if="showTrialExpiredButton",
                                )
                                | {{ $i18n.t('common.common_tariff_trial_expired') }}
                            cs-button.button-link(
                                    color="blue",
                                    pattern='primary-outline',
                                    @click='showTrialModal = true',
                                    v-if="showTrialActivationButton",
                                    :narrow="isNarrowButtons"
                                )
                                | {{ $i18n.t('common.common_use_tariff_trial') }}
                            cs-button.button-link(
                                    color="blue",
                                    pattern='primary-outline',
                                    @click='showActivatePaidNowModal = true',
                                    v-if="showActivatePaidNowButton",
                                    :narrow="isNarrowButtons"
                                )
                                | {{ $i18n.t('common.common_activate_paid_tariff_now') }}
                            cs-button.button-link(
                                    color="green",
                                    pattern='primary-outline',
                                    v-if="showTrialActivatedMessage",
                                    :narrow="isNarrowButtons"
                                )
                                | {{ $i18n.t('common.common_tariff_trial_activated') }}
                        cs-button.button-link(
                            slot="button",
                            v-if="$can('addItem', type) && type === 'teacher'",
                            :color="isNarrowButtons ? 'blue' : 'green'",
                            pattern='primary-outline',
                            @click=`$router.push({
                                name: routeName,
                                params: {
                                    type: isEducationMaterials ? 'education-material' : type
                                }
                            })`
                            :disabled='isLoading || blockAccessToButton || isTeacherBillingAndSchoolAccountStatusInactive'
                            :narrow="isNarrowButtons"
                        )
                            svg-icon(name="plus" size="large" slot="icon")
                            | {{ $i18n.t('list.list_list_add') }} {{ declination[type]['add'] }}
                template(slot='button', v-else-if="isDropParametersAvailable")
                    cs-button(type="button", pattern="primary-outline", color="blue", narrow, @click="resetResults")
                        | {{ $i18n.t('fields.fields_dropParameters') }}
                template(slot='header')
                    template(v-if="type === 'rating' || type === 'battle-rating'")
                        | {{ $i18n.t('list.list_list_rating') }}
                    template(v-else-if="type === 'educationMaterials'")
                        | {{ $i18n.t('list.list_list_list') }}
                        | {{ declination[globalType]['list'] }}
                    template(v-else)
                        | {{ $i18n.t('list.list_list_list') }}
                        | {{ declination[type]['list'] }}
                template(slot='fields', v-if="isFieldsDisplayed")
                    div(
                        v-if="showFieldsForType",
                        :is="!isMotivationType ? `${type}-fields` : 'motivation-points-history-fields'",
                        @search='search',
                        :school-id='$route.query.schoolId || schoolId',
                        :grade-id='$route.query.gradeId',
                        :user-id='$route.query.userId'
                        ref="fields"
                    )
                    div(v-else)
                template(slot='preview')
                    div(v-if='isLoading')
                        cs-loader
                    div(v-else)
                        template(v-if='items.length > 0')
                            template(v-if='isTableList')
                                div(
                                    :is="!isMotivationType ? `${type}-table` : 'motivation-points-history-table'",
                                    :items='items',
                                    :per-page='perPage',
                                    :summary='summary',
                                    @getSummary='summary = $event',
                                    @delete='deleteItem',
                                    :selected-presentation-id='selectedPresentationId',
                                    @selectPresentation='selectPresentation',
                                    @startPresentation='startPresentation',
                                    @deletePresentation='deletePresentation'
                                )
                            template(v-else)
                                div(
                                    v-for='(item, index) in items',
                                    :is="!isMotivationType ? `${type}-preview` : 'motivation-points-history-preview'",
                                    :key='item.id',
                                    :index='index',
                                    :type="type",
                                    :page="currentPage"
                                    :is-last='index + 1 === items.length && items.length > 1',
                                    :profile='item',
                                    :search-params='searchParams',
                                    @delete='deleteItem',
                                    @loading='isLoading = $event'
                                )
                        .empty(v-else)
                            div(v-if="type === 'points-history'")
                                template(v-if="user.type === 'student'")
                                    template(v-if="searchParams.sourceType === 'olympiadLevelStage'")
                                        | {{ $i18n.t('list.list_list_pointsOlympiadsNotExist') }}
                                    template(v-else)
                                        | {{ $i18n.t('list.list_list_pointsNotExist') }}
                                template(v-else)
                                    | {{ $i18n.t('list.list_list_nobodyPoints') }}
                            div(v-else-if="type === 'rating'")
                                | {{ $i18n.t('list.list_list_noRating') }}
                            div(v-else)
                                | {{ $i18n.t('list.list_list_notAddedToSystem') }}
                                | {{ declination[type]['not exist'] }}
                            div.empty__button-block(v-if='!withoutCreate')
                                cs-button(
                                    v-if="user.isSuperadmin || (user.type === 'admin' && type === 'student')",
                                    type="button",
                                    color="blue",
                                    pattern="primary-outline"
                                    @click=`$router.push({name: routeName, params: {type}})`,
                                    :disabled='areSchoolsBlocked'
                                )
                                    | {{ $i18n.t('list.list_list_add') }}
                                    | {{ declination[type]['add'] }}
                                cs-button(
                                        v-if="!user.isSuperadmin && (type === 'teacher')",
                                        type="button",
                                        color="blue",
                                        pattern="primary-outline"
                                        @click=`$router.push({name: routeName, params: {type}})`,
                                        :disabled='isTeacherBillingAndSchoolAccountStatusInactive'
                                    )
                                    | {{ $i18n.t('list.list_list_add') }}
                                    | {{ declination[type]['add'] }}
                        divider(v-if="!isNarrowButtons" :margin="'20px auto 0'")
                        slot(name="run" v-if="$slots['run']")
                        pagination(
                            :last-page="lastPage",
                            :current-page="currentPage",
                            :total="total",
                            :length="items.length",
                            :from="from",
                            :to="to"
                        )
            div(v-else)
                .content-box.list
                    .box-body
                        .column.is-12-mobile.list-item.field-column
                            | {{ $i18n.t('errors.page_not_access') }}
            trial-tariff-modal(
                v-if="showTrialModal && extendedTariff"
                :extendedTariff="extendedTariff"
                @close="showTrialModal = false"
            )
            activate-paid-tariff-modal(
                v-if="showActivatePaidNowModal"
                :tariff="activatePaidNowTariff"
                @close="showActivatePaidNowModal = false"
            )
        cs-loader(v-else)
</template>

<script>
    import _ from 'lodash';
    import { mapState } from 'vuex';

    const StudentPreview = () => import('./Student/Preview.vue');
    const StudentFields = () => import('./Student/Fields.vue');
    const AdminPreview = () => import('./Admin/Preview.vue');
    const AdminFields = () => import('./Admin/Fields.vue');
    const TeacherPreview = () => import('./Teacher/Preview.vue');
    const TeacherFields = () => import('./Teacher/Fields.vue');

    const SchoolFields = () => import('./School/Fields.vue');
    const SchoolPreview = () => import('./School/Preview.vue');
    const GradeFields = () => import('./Grade/Fields.vue');
    const GradePreview = () => import('./Grade/Preview.vue');
    const CourseFields = () => import('./Course/Fields.vue');
    const CoursePreview = () => import('./Course/Preview.vue');

    const HomeworkFields = () => import('./homework/Fields.vue');
    const HomeworkPreview = () => import('./homework/Preview.vue');
    const HomeworkTemplateFields = () => import('./template/Fields.vue');
    const HomeworkTemplatePreview = () => import('./template/Preview.vue');

    const LessonConductingTemplateFields = () => import('./template/Fields.vue');
    const LessonConductingTemplatePreview = () => import('./template/Preview.vue');

    const ProgressHomeworkFields = () => import('./Progress/Fields.vue');
    const ProgressOlympiadFields = () => import('./Progress/Fields.vue');
    const ProgressBattleFields = () => import('./Progress/Fields.vue');
    const ProgressHomeworkTable = () => import('./Progress/Homework/Table.vue');
    const ProgressOlympiadTable = () => import('./Progress/Olympiad/Table.vue');
    const ProgressBattleTable = () => import('./Progress/Battle/Table.vue');

    const MotivationPointsHistoryTable = () => import('./HistoriesProgress/Table.vue');
    const MotivationPointsHistoryFields = () => import('./HistoriesProgress/Fields.vue');
    const MotivationPointsHistoryPreview = () => import('./HistoriesProgress/Preview.vue');

    const PointsHistoryHomeworkTable = () => import('./PointsHistory/Table.vue');
    const PointsHistoryOlympiadTable = () => import('./PointsHistory/Table.vue');
    const PointsHistoryBattleTable = () => import('./PointsHistory/Table.vue');
    const PointsHistoryHomeworkFields = () => import('./PointsHistory/Fields.vue');
    const PointsHistoryOlympiadFields = () => import('./PointsHistory/Fields.vue');
    const PointsHistoryBattleFields = () => import('./PointsHistory/Fields.vue');

    const RatingTable = () => import('./Rating/Table.vue');
    const RatingFields = () => import('./Rating/Fields.vue');

    const BattleRatingTable = () => import('./BattleRating/Table.vue');
    const BattleRatingFields = () => import('./BattleRating/Fields.vue');

    const TransactionsFields = () => import('./Billing/Transactions/Fields.vue');
    const TransactionsTable = () => import('./Billing/Transactions/Table.vue');
    const StatisticsFields = () => import('./Billing/Statistics/Fields.vue');
    const StatisticsPreview = () => import('./Billing/Statistics/Preview.vue');
    const StocksFields = () => import('./Billing/Stocks/Fields.vue');
    const StocksPreview = () => import('./Billing/Stocks/Preview.vue');
    const PaymentServicesPreview = () => import('./Billing/PaymentServices/Preview.vue');
    const SubscriptionsPreview = () => import('./Billing/Subscriptions/Preview.vue');
    const SubscriptionsFields = () => import('./Billing/Subscriptions/Fields.vue');

    const TariffsFields = () => import('./Tariffs/Fields.vue');
    const TariffsPreview = () => import('./Tariffs/Preview.vue');

    import ListBox from './ListBox.vue';
    import Pagination from './Pagination.vue';
    const ItemStateModal = () => import('../../modals/ItemStateModal.vue');

    import paginate from '../../utils/paginate';
    import declination from '../../utils/declination';

    import UserApi from '../../api/user/user';
    import SchoolApi from '../../api/school';
    import CourseApi from '../../api/course';
    import GradeApi from '../../api/grade';

    import HomeworkApi from '../../api/homework/homework';

    import GameStatApi from '../../api/games/gameStat';
    import PointsHistoryApi from '../../api/stats/pointsHistory';
    import RatingApi from '../../api/rating';
    import TemplateApi from '../../api/templates/template';
    import MotivationPointsHistoryApi from '../../api/stats/motivation-points-history';

    import TransactionsApi from '../../api/billing/transactions';
    import StatisticsApi from '../../api/billing/statistics';
    import StocksApi from '../../api/billing/stocks';
    import PaymentServicesApi from '../../api/billing/paymentServices';
    import SubscriptionsApi from '../../api/billing/subscriptions';

    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';

    import PresentationsThemesApi from '../../api/games/presentationThemeApi';
    import PresentationsApi from '../../api/games/presentationsApi';

    const PresentationsTable = () => import('./presentations/Table.vue');
    const PresentationsFields = () => import('./presentations/Fields.vue');

    import BaseApi from '../../api/index';
    import TariffsApi from '@/api/tariffs/tariffs';
    import TrialTariffModal from '@/components/popups/TrialTariffModal.vue';
    import ActivatePaidTariffModal from '@/components/popups/ActivatePaidTariffModal.vue';

    const EXTENDED_TARIFF = 3;
    const EXPORTABLE_LISTS = ['student', 'teacher', 'admin', 'school', 'grade', 'course', 'transactions', 'statistics'];
    const TABLE_LISTS = [
        'progress-homework',
        'progress-olympiad',
        'progress-battle',
        'points-history-olympiad',
        'points-history-homework',
        'points-history-battle',
        'rating',
        'battle-rating',
        'miles-history',
        'detective-points-history',
        'transactions',
        'presentations',
    ];
    const MAP_MOTIVATION = 'map';
    const DETECTIVE_MOTIVATION = 'detective';
    const MOTIVATION_TYPES = ['miles-history', 'detective-points-history'];
    const TYPES_WITH_POINTS = [
        'points-history-homework',
        'points-history-olympiad',
        'points-history-battle',
        'progress-homework',
        'progress-olympiad',
        'progress-battle',
    ];

    const PAGE_WITHOUT_FIELDS = ['payment-services'];

    export default {
        mixins: [paginate, declination, BillingBlockMixin],
        props: {
            type: {
                type: String,
                required: true,
            },
            page: {},
            withoutCreate: {},
            startParameters: {},
            selectedPresentationId: {},
            isEducationMaterials: {},
            isSuccessfullyCreated: {},
            isSuccessfullyUpdated: {},
        },
        data() {
            return {
                showTrialModal: false,
                showActivatePaidNowModal: false,
                items: [],
                lastPage: null,
                total: null,
                currentPage: null,
                isLoading: false,
                searchParams: {},
                from: null,
                to: null,
                schoolId: null,
                declination: null,
                isExcelLoading: false,
                perPage: null,
                motivationType: '',
                summary: null,
                isItemDeleted: false,
                isItemUpdated: false,
                isItemCreated: false,
                cancelTokenSource: null,
                isShowDownloadButton: false,
                linkExcelFile: null,
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            showTrialExpiredButton() {
                return (
                    this.type === 'tariffs' && this.user.school.tariffTrial && this.user.school.tariffTrial.isFinished
                );
            },
            showTrialActivationButton() {
                return (
                    this.type === 'tariffs' &&
                    (this.user.type === 'admin' || this.user.isSuperadmin) &&
                    this.user.school.tariffId === 1 &&
                    ((this.user.school.tariffTrial && !this.user.school.tariffTrial?.isFinished) ||
                        !this.user.school.tariffTrial)
                );
            },
            showActivatePaidNowButton() {
                const school = this.user && this.user.school ? this.user.school : null;
                const changeRequest = school && school.changeTariffRequest;
                const nextTariffId = changeRequest && changeRequest.nextTariffId;
                const trial = school && school.tariffTrial;
                const accountActive = school && school.account && !!school.account.status;
                const isSchoolAdmin =
                    this.user && this.user.type === 'admin' && !this.user.isSuperadmin && !this.user.isManagerOrSupport;

                return (
                    this.type === 'tariffs' &&
                    isSchoolAdmin &&
                    school &&
                    Number(school.tariffId) === 1 &&
                    [2, 3, 4].indexOf(Number(nextTariffId)) !== -1 &&
                    accountActive &&
                    (!trial || trial.isFinished) &&
                    new Date().getDate() !== 1
                );
            },
            showTrialActivatedMessage() {
                return (
                    this.type === 'tariffs' &&
                    (this.user.type === 'admin' || this.user.isSuperadmin) &&
                    this.user.school.tariffTrial &&
                    !this.user.school.tariffTrial?.isFinished &&
                    this.user.school.tariffId !== 1
                );
            },
            extendedTariff() {
                return this.items.find(item => item.id === EXTENDED_TARIFF);
            },
            activatePaidNowTariff() {
                const school = this.user && this.user.school ? this.user.school : null;
                const nextTariffId =
                    school && school.changeTariffRequest ? Number(school.changeTariffRequest.nextTariffId) : null;
                if (!nextTariffId || !this.items || !this.items.length) return null;
                return this.items.find(item => Number(item.id) === nextTariffId) || null;
            },
            showFieldsForType() {
                if (this.type === 'payment-services') {
                    return false;
                }

                if (this.type === 'tariffs') {
                    const user = this.user || {};
                    return (
                        user.school?.changeTariffRequest?.nextTariffId &&
                        user.type === 'admin' &&
                        !user.isSuperadmin &&
                        !user.isManagerOrSupport
                    );
                }

                return true;
            },
            api() {
                switch (this.type) {
                    case 'student':
                    case 'teacher':
                    case 'admin':
                        return UserApi;
                    case 'school':
                        return SchoolApi;
                    case 'transactions':
                        return TransactionsApi;
                    case 'grade':
                        return GradeApi;
                    case 'course':
                        return CourseApi;
                    case 'homework':
                        return HomeworkApi;
                    case 'progress-homework':
                    case 'progress-olympiad':
                    case 'progress-battle':
                        return GameStatApi;
                    case 'points-history-homework':
                    case 'points-history-olympiad':
                    case 'points-history-battle':
                        return PointsHistoryApi;
                    case 'rating':
                    case 'battle-rating':
                        return RatingApi;
                    case 'homework-template':
                    case 'lesson-conducting-template':
                        return TemplateApi;
                    case 'miles-history':
                    case 'detective-points-history':
                        return MotivationPointsHistoryApi;
                    case 'stocks':
                        return StocksApi;
                    case 'subscriptions':
                        return SubscriptionsApi;
                    case 'statistics':
                        return StatisticsApi;
                    case 'payment-services':
                        return PaymentServicesApi;
                    case 'presentations':
                        return PresentationsThemesApi;
                    case 'tariffs':
                        return TariffsApi;
                    default:
                        throw new Error('List API is not defined');
                }
            },
            globalType() {
                if (['student', 'teacher', 'admin'].includes(this.type)) {
                    return 'user';
                }
                if (this.isEducationMaterials) {
                    return 'education-material';
                }
                return this.type;
            },
            isExcelAvailable() {
                return EXPORTABLE_LISTS.includes(this.type);
            },
            isTableList() {
                return TABLE_LISTS.includes(this.type);
            },
            isMotivationType() {
                return MOTIVATION_TYPES.includes(this.type);
            },
            isCreateButtonAvailable() {
                if (!this.withoutCreate) {
                    if (this.type === 'homework-template') {
                        return this.user && this.user.pointsAccesses.length;
                    }
                    if (this.isEducationMaterials) {
                        return this.user.isSuperadmin || this.user.isManagerOrSupport;
                    }
                    return true;
                }
                return false;
            },
            isDropParametersAvailable() {
                return [
                    'points-history',
                    'miles-history:list',
                    'detective-points-history:list',
                    'histories-progress',
                    'progress',
                ].includes(this.$route.name);
            },
            routeName() {
                return `${this.globalType}:create`;
            },
            isNarrowButtons() {
                return [
                    'user',
                    'grade',
                    'course',
                    'school',
                    'stocks',
                    'education-material',
                    'presentations',
                    'homework',
                    'homework-template',
                    'lesson-conducting-template',
                    'statistics',
                    'transactions',
                    'payment-services',
                    'subscriptions',
                ].includes(this.globalType);
            },
            isFieldsDisplayed() {
                return !PAGE_WITHOUT_FIELDS.includes(this.globalType);
            },
            blockAccessToButton() {
                return this.$route.name === 'user:list' && this.$route.params && this.$route.params.type === 'teacher'
                    ? false
                    : this.areSchoolsBlocked;
            },
        },
        watch: {
            $route: {
                handler(route) {
                    let routeQuery = this.$route.query;
                    if (routeQuery.schoolId) {
                        this.searchParams.schoolId = routeQuery.schoolId;
                    }
                    if (routeQuery.gradeId) {
                        this.searchParams.gradeId = routeQuery.gradeId;
                    }
                    if (routeQuery.userId) {
                        this.searchParams.userId = routeQuery.userId;
                    }
                    if (_.isEmpty(this.$route.query)) {
                        this.searchParams = {};
                        if (this.startParameters) {
                            this.searchParams = _.cloneDeep(this.startParameters);
                        }
                    }
                    if (!this.searchParams.sourceType && this.startParameters && this.startParameters.sourceType) {
                        this.searchParams.sourceType = this.startParameters.sourceType;
                    }
                    let searchParams = this.$store.state.lists.searchParams[route.path];
                    if (this.page > 1 || !searchParams) {
                        this.fetchData();
                    } else {
                        this.search(searchParams);
                    }
                },
                immediate: true,
            },
            isSuccessfullyUpdated: {
                handler(value) {
                    this.isItemUpdated = value;
                },
                immediate: true,
            },
            isSuccessfullyCreated: {
                handler(value) {
                    this.isItemCreated = value;
                },
                immediate: true,
            },
        },
        beforeRouteEnter(to, from, next) {
            next(self => {
                if (!from.name?.match(/.*:start/)) {
                    self.$store.dispatch('setLessonConductingTemplate', null);
                }
            });
        },
        beforeRouteUpdate(to, from, next) {
            if (from.params.pointsAccess) {
                to.params.pointsAccess = from.params.pointsAccess;
            }
            next();
        },
        created() {
            if (!this.user.isSuperadmin && this.user.type === 'student') {
                this.$set(this, 'schoolId', this.user.school.id);
            }
        },
        methods: {
            getExcelExportUrl() {
                let url = '/api';
                switch (this.type) {
                    case 'student':
                    case 'teacher':
                    case 'admin':
                        url += '/user';
                        break;
                    case 'school':
                    case 'grade':
                    case 'course':
                        url += '/' + this.type;
                        break;
                    case 'transactions':
                        url += '/download-file?file=';
                        break;
                    case 'statistics':
                        url += '/billing-' + this.type;
                        break;
                }
                !this.searchParams.status && (this.searchParams.status = 'active');
                if (this.type === 'transactions') {
                    return url;
                }
                url += '/export' + '?type=' + this.type;
                Object.entries(this.searchParams).forEach(([paramName, paramValue]) => {
                    if (paramValue && (paramValue !== '' || (Array.isArray(paramValue) && paramValue.length > 0))) {
                        Array.isArray(paramValue)
                            ? paramValue.forEach(value => {
                                  url += '&' + _.snakeCase(paramName) + '[]=' + value;
                              })
                            : (url += '&' + _.snakeCase(paramName) + '=' + paramValue);
                    }
                });
                return url;
            },
            fetchData() {
                this.isLoading = true;
                if (this.cancelTokenSource) {
                    this.cancelTokenSource.cancel();
                }
                let routeQuery = this.$route.query;
                if (routeQuery.schoolId) {
                    this.searchParams.schoolId = routeQuery.schoolId;
                }
                if (routeQuery.gradeId) {
                    this.searchParams.gradeId = routeQuery.gradeId;
                }
                if (routeQuery.userId) {
                    this.searchParams.userId = routeQuery.userId;
                }
                let form = {
                    page: this.page,
                    type: this.type === 'rating' || this.type === 'battle-rating' ? 'student' : this.type,
                    status: 'active',
                };
                form = _.assign(form, this.searchParams);
                if (this.type === 'homework-template' || this.type === 'lesson-conducting-template') {
                    form.type = this.type.replace('-template', '');
                }
                if (this.type === 'rating' && !form.pointsAccess) {
                    form = Object.assign(form, { pointsAccess: this.user.pointsAccesses[0] || '' });
                }
                if (this.type === 'battle-rating') {
                    if (!this.searchParams.schoolId && !this.user.isSuperadmin && !this.user.isManagerOrSupport) {
                        form = Object.assign(form, { schoolId: this.user.school.id });
                    }
                    form = Object.assign(form, {
                        forBattle: 1,
                        course_type: _.kebabCase(this.searchParams.course_type),
                    });
                }
                if (this.type === 'transactions') {
                    form = Object.assign(form, {
                        schoolsTypes: this.searchParams.schoolsTypes || 'default',
                    });
                    if (this.$route.params.accountId || this.$route.params.studentName) {
                        if (this.$route.params.isStudentPayed) {
                            form.schoolsTypes = 'studentPayed';
                            form.studentName = this.$route.params.studentName;
                            this.searchParams.studentName = this.$route.params.studentName;
                        } else {
                            form.schoolsTypes = 'default';
                            this.searchParams.schoolsTypes = 'default';
                            form.accountId = this.$route.params.accountId;
                        }
                    }
                    if (!(form.dateFrom && form.dateTo)) {
                        form = Object.assign(form, {
                            dateFrom: this.$moment()
                                .startOf('month')
                                .format('YYYY-MM-DD'),
                            dateTo: this.$moment()
                                .endOf('month')
                                .format('YYYY-MM-DD'),
                        });
                    }
                }
                if (this.type === 'statistics' && !(form.dateFrom && form.dateTo)) {
                    form = Object.assign(form, {
                        dateFrom: this.$moment()
                            .startOf('month')
                            .format('YYYY-MM-DD'),
                        dateTo: this.$moment()
                            .endOf('month')
                            .format('YYYY-MM-DD'),
                    });
                }
                if (TYPES_WITH_POINTS.includes(this.type)) {
                    if (this.$route.params.pointsAccess) {
                        form.pointsAccess = this.$route.params.pointsAccess;
                    } else {
                        form.pointsAccess = this.searchParams.pointsAccess || this.user.pointsAccesses[0] || '';
                    }
                }
                if (this.type === 'homework-template' || this.type === 'lesson-conducting-template') {
                    form.coursesType =
                        (this.user.pointsAccesses.includes(this.searchParams.coursesType) &&
                            this.searchParams.coursesType) ||
                        this.user.pointsAccesses[0] ||
                        '';
                }
                if (this.type.includes('miles')) {
                    this.motivationType = MAP_MOTIVATION;
                } else if (this.type.includes('detective')) {
                    this.motivationType = DETECTIVE_MOTIVATION;
                }
                if (this.type === 'miles-history' || this.type === 'detective-points-history') {
                    form = Object.assign(form, { motivationType: this.motivationType });
                }
                if (this.type === 'presentations') {
                    form.isEducationMaterial = this.isEducationMaterials;
                }
                if (this.type === 'presentations' && !form.sort) {
                    form.sort = 'created_at';
                }
                let type = this.type;
                this.cancelTokenSource = BaseApi.generateCancelToken();
                this.api
                    .list(form, this.cancelTokenSource.token)
                    .then(data => {
                        if (this.type !== type) {
                            return;
                        }
                        this.items = data.data.map(item => {
                            this.$set(item, 'relation', {
                                chosenRelationItems: [],
                                relationItemsIds: [],
                                relationName: '',
                                visibleOnlyToMe: false,
                            });
                            if (item.usersFilterType) {
                                if (item.usersFilterType === 'schools') {
                                    item.relation.relationName = 'school';
                                }
                                if (item.usersFilterType === 'grade') {
                                    item.relation.relationName = 'grade';
                                }
                                if (item.usersFilterType === 'only_creator') {
                                    item.relation.relationName = 'only_creator';
                                }
                                if (item.usersFilterType === null) {
                                    item.relation.relationName = null;
                                }
                            }
                            return item;
                        });
                        if (this.type === 'statistics' || this.type === 'transactions') {
                            this.lastPage = data.meta.lastPage;
                            this.total = data.meta.total;

                            this.currentPage = data.meta.currentPage;
                            this.from = data.meta.from;
                            this.to = data.meta.to;
                            this.perPage = data.meta.perPage;
                        } else {
                            this.lastPage = data.lastPage;
                            this.total = data.total;
                            this.currentPage = data.currentPage;
                            this.from = data.from;
                            this.to = data.to;
                            this.perPage = data.perPage;
                        }
                        if (this.lastPage > 0 && this.currentPage > this.lastPage) {
                            this.currentPage = this.lastPage;
                        }
                        if (this.$route.fullPath === `/${form.type}` || this.$route.fullPath === `/user/${form.type}`) {
                            this.isLoading = false;
                        }
                        this.$nextTick(() => {
                            if (this.$route.params.savedHeightPosition) {
                                window.scrollTo({
                                    top: this.$route.params.savedHeightPosition,
                                    behavior: 'smooth',
                                });
                            }
                        });
                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (BaseApi.getPlainAxios().isCancel(error)) {
                            return;
                        }
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_data'));
                    });
            },
            search(params) {
                params = _.mapKeys(params, (value, key) =>
                    (value && value.id) || Object.prototype.hasOwnProperty.call(this.searchParams, key + 'Id')
                        ? key + 'Id'
                        : key
                );
                params = _.mapKeys(params, (value, key) =>
                    (value && Array.isArray(value)) ||
                    Object.prototype.hasOwnProperty.call(this.searchParams, key + 'Ids')
                        ? key + 'Ids'
                        : key
                );
                params = _.mapValues(params, value => (value && value.id ? value.id : value));
                params = _.mapValues(params, value =>
                    value && Array.isArray(value) ? value.map(item => item.id) : value
                );
                this.searchParams = _.assign(this.searchParams, params);
                if (this.page && this.page > 1) {
                    this.$router.push({ query: { page: 1 } });
                } else {
                    this.fetchData();
                }
            },
            deleteItem(id) {
                this.isLoading = true;
                this.api
                    .delete(id)
                    .then(() => {
                        this.isItemDeleted = true;
                        this.fetchData();
                    })
                    .catch(err => {
                        if (err.response && err.response.data.errors) {
                            let errors = err.response.data.errors;
                            for (let field in errors) {
                                if (Object.prototype.hasOwnProperty.call(errors, field)) {
                                    errors[field].forEach(val => {
                                        this.$toasted.error(val);
                                    });
                                }
                            }
                        }
                        this.fetchData();
                    });
            },
            deletePresentation(id) {
                this.isLoading = true;
                PresentationsApi.delete(id)
                    .then(() => {
                        this.$toasted.success(this.$i18n.t('list.list_list_deletedSuccessfully'));
                        this.fetchData();
                    })
                    .catch(err => {
                        if (err.response && err.response.data.errors) {
                            let errors = err.response.data.errors;
                            for (let field in errors) {
                                if (Object.prototype.hasOwnProperty.call(errors, field)) {
                                    errors[field].forEach(val => {
                                        this.$toasted.error(val);
                                    });
                                }
                            }
                        }
                        this.fetchData();
                    });
            },
            selectPresentation(presentation) {
                this.$emit('selectPresentation', presentation);
            },
            startPresentation(presentation) {
                this.$emit('startPresentation', presentation);
            },
            queryPageNumber(pageNumber) {
                if (this.type === 'presentations') {
                    return { slug: this.$route.query.slug, page: pageNumber };
                }
                return { page: pageNumber };
            },
            setDefaultStates() {
                this.isItemCreated = false;
                this.isItemUpdated = false;
                this.isItemDeleted = false;
            },
            resetResults() {
                this.$refs.fields.resetResults();
            },
        },
        components: {
            TrialTariffModal,
            ActivatePaidTariffModal,
            ListBox,
            Pagination,
            ItemStateModal,

            StudentPreview,
            StudentFields,
            TeacherPreview,
            TeacherFields,
            AdminPreview,
            AdminFields,

            SchoolPreview,
            SchoolFields,
            GradePreview,
            GradeFields,
            CourseFields,
            CoursePreview,

            HomeworkFields,
            HomeworkPreview,
            HomeworkTemplateFields,
            HomeworkTemplatePreview,

            LessonConductingTemplateFields,
            LessonConductingTemplatePreview,

            ProgressHomeworkFields,
            ProgressHomeworkTable,
            ProgressBattleFields,
            ProgressOlympiadFields,
            ProgressOlympiadTable,
            ProgressBattleTable,

            PointsHistoryHomeworkTable,
            PointsHistoryOlympiadTable,
            PointsHistoryBattleTable,
            PointsHistoryHomeworkFields,
            PointsHistoryOlympiadFields,
            PointsHistoryBattleFields,

            MotivationPointsHistoryFields,
            MotivationPointsHistoryTable,
            MotivationPointsHistoryPreview,

            RatingTable,
            RatingFields,

            BattleRatingTable,
            BattleRatingFields,

            TransactionsFields,
            TransactionsTable,
            StocksPreview,
            StocksFields,
            StatisticsFields,
            StatisticsPreview,
            PaymentServicesPreview,
            SubscriptionsPreview,
            SubscriptionsFields,

            TariffsFields,
            TariffsPreview,

            PresentationsTable,
            PresentationsFields,
        },
    };
</script>

<style lang="scss" scoped>
    .list-button-text {
        font-weight: 500;
    }

    .field-column {
        display: flex;
        padding-bottom: 0.25rem;
        padding-top: 0.25rem;
    }

    .tariff-header-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px 16px;
    }

    .field-column__link {
        @include media($md) {
            margin-left: 20px;
        }
    }

    .list__footer {
        margin-top: 30px;
    }

    .button-download-excel {
        margin-left: 5px;
    }
</style>
